module.exports = __webpack_public_path__ + "media/images/photo/Commercial/Commercial-01-e79776fc166cd2b98f2f2b3d996d550d.png";